<template>
    <div>
        <div class="ml-auto mb-2">
            <form class="form-inline my-2 my-lg-0">
                <div class="row col-12">
                    <div class="offset-3 col-3">
                        <span style="font-size: 10px;color: red">
                            *เลือกได้ไม่เกิน 7 วัน
                        </span>
                    </div>
                    <div class="col-6"></div>
                    <div class="col-3 d-flex align-items-end">
                        <multiselect
                            style="width: 100%;height: 43px"
                            :options="optionProducts"
                            :customLabel="LabelSkuWithName"
                            v-model="search.product"
                            placeholder="ค้นหาสินค้า"
                            :show-labels="false"
                            :close-on-select="false"
                            multiple
                            :searchable="true"
                            track-by="id"
                        >
                        </multiselect>
                    </div>
                    <div class="col-3 d-flex align-items-end">
                        <date-picker
                            style="width: 100%;height: 43px"
                            type="datetime"
                            :format="changeFormat"
                            :range="true"
                            :lang="lang"
                            v-model="search.time"
                            confirm
                            placeholder="วันที่บิล"
                            @change="handleDateChange"
                        >
                        </date-picker>
                    </div>
                    <div class="col-3 d-flex align-items-end">
                        <multiselect
                            style="width: 100%;height: 43px"
                            multiple
                            placeholder="เลือกประเภทสินค้า"
                            :customLabel="customLabelType"
                            track-by="value"
                            :options="optionProductType"
                            v-model="search.product_type_id"
                        ></multiselect>
                    </div>
                    <div class="col-3 d-flex align-items-end">
                        <button
                            class="btn btn-success my-2 my-sm-0"
                            type="button"
                            @click="searchProduct"
                        >
                            <icon name="search"></icon>
                            ค้นหา
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-12 table-responsive table-container">
            <table
                v-if="response != null"
                style="text-align: center"
                class="table table-bordered table-sticky"
            >
                <thead>
                    <tr>
                        <th style="vertical-align: middle;" rowspan="2">No</th>
                        <th
                            v-for="(i, index) in response['skuHead']"
                            :key="'header1-' + index"
                        >
                            {{ i }}
                        </th>
                        <th
                            style="vertical-align: middle;width: 100px"
                            rowspan="2"
                        >
                            TN เลขที่บิล
                        </th>
                        <th style="vertical-align: middle;" rowspan="2">
                            เวลา
                        </th>
                        <th style="vertical-align: middle;" colspan="2">
                            คนขับรถ
                        </th>
                    </tr>
                    <tr>
                        <th
                            v-for="(i, index) in response['skuBody']"
                            :key="'header2-' + index"
                        >
                            {{ i }}
                        </th>
                        <th>ทะเบียนรถ</th>
                        <th>ชื่อ</th>
                    </tr>
                </thead>
                <tbody v-if="response.body.length > 0">
                    <tr
                        v-for="(invoice, invoiceIndex) in response.body"
                        :key="'header2-' + invoiceIndex"
                    >
                        <!-- Display the invoice ID -->
                        <td>{{ invoiceIndex + 1 }}</td>
                        <td
                            v-for="(quantity, index) in invoice.products"
                            :key="'quantity-' + index"
                        >
                            {{ quantity }}
                        </td>
                        <td>{{ invoice.invoice_number }}</td>
                        <td>{{ invoice.time }}</td>
                        <td>{{ invoice.license_plate }}</td>
                        <td>{{ invoice.name }}</td>
                    </tr>
                    <tr>
                        <td>รวม</td>
                        <td
                            v-for="(total,
                            index) in response.total_quantity_per_product"
                            :key="'quantity-' + index"
                        >
                            {{ total }}
                        </td>
                        <td colspan="4"></td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td :colspan="response.skuHead.length + 6">No data</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div
            class="vh-100 d-flex justify-content-center align-items-center"
            v-if="loading"
        >
            <div class="loader"></div>
        </div>
        <b-modal hide-header hide-footer ref="filter_emp_nation">
            <div class="text-left">
                <p style="font-size: 16px">กรุณาระบุวันที่บิล</p>
                <p style="color: #bebebe">
                    เพื่อให้ระบบสามารถดำเนินการได้อย่างถูกต้องและครบถ้วน
                    กรุณากรอกวันที่บิลตามข้อมูลที่ระบุไว้ใน เอกสารของคุณ
                </p>
            </div>
            <div class="d-flex justify-content-center mt-4">
                <button
                    class="btn btn-primary"
                    type="button"
                    @click="closeModal"
                >
                    ตกลง
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import {domain} from "../../../util/Constants";
import axios from "axios";

export default {
    name: "products-type",
    components: {
        Multiselect,
        DatePicker
    },
    data() {
        return {
            delete_id: "",
            changeFormat: {
                stringify: date => {
                    let date_moment = moment(date).format("YYYY");
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format("DD/MM/" + year) : null;
                },
                parse: value => {
                    return value
                        ? moment(value, "DD/MM/YYYY")
                              .subtract(543, "y")
                              .toDate()
                        : null;
                }
            },
            lang: {
                days: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
                months: [
                    "มกราคม",
                    "กุมภาพันธ์",
                    "มีนาคม",
                    "เมษายน",
                    "พฤษภาคม",
                    "มิถุนายน",
                    "กรกฎาคม",
                    "สิงหาคม",
                    "กันยายน",
                    "ตุลาคม",
                    "พฤศจิกายน",
                    "ธันวาคม"
                ],
                pickers: [
                    "ถัดไป 7 วัน",
                    "ถัดไป 30 วัน",
                    "ก่อนหน้า 7 วัน",
                    "ก่อนหน้า 30 วัน"
                ],
                placeholder: {
                    date: "วว/ดด/ปปปป"
                }
            },
            response: null,
            quantity: [],
            search: {
                product: [], // Default to empty array,
                text: "",
                product_type_id: [],
                time: ""
            },
            loading: false // Set to true initially
        };
    },
    created() {
        this.getPage(1);
        this.domain = domain;
    },
    computed: {
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            ProductSpecial: state => {
                return state.Products.special;
            },
            dataPaginate: state => {
                return state.Products.specialPaginate;
            },
            optionProducts: state => {
                return state.ProductType.productSKU;
            },
            optionProductType: state => {
                return [
                    ...state.ProductType.data.map(type => ({
                        value: type.id,
                        text: type.name
                    }))
                ];
            }
        })
    },
    mounted() {
        console.log('Component mounted');
        this.$nextTick(() => {
            this.adjustStickyHeader();
            window.addEventListener('resize', this.adjustStickyHeader);
        });
    },
    watch: {
        response: {
            handler() {
                this.$nextTick(() => {
                    console.log('Response changed, adjusting header');
                    this.adjustStickyHeader();
                });
            },
            deep: true
        }
    },
    methods: {
        getPage() {
            this.$store.dispatch("ProductType/productSKU");
        },

        LabelSkuWithName(option) {
            if (this.optionProducts.length > 0) {
                return `${option.sku} - ${option.name}`;
            }
        },
        async searchProduct() {
            try {
                if (this.search.time == "") {
                    this.$refs.filter_emp_nation.show();
                } else {
                    let date = this.search.time.map(ts => {
                        let d = new Date(ts);
                        let formatter = new Intl.DateTimeFormat("en-CA", {
                            timeZone: "Asia/Bangkok",
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: false
                        });

                        let formatted = formatter
                            .format(d)
                            .replace(",", "")
                            .replace(/\//g, "-");
                        return formatted; // Keeps YYYY-MM-DD HH:mm:ss
                    });

                    this.loading = true;
                    // Extract the year, month, and day
                    const productIds = this.search.product.map(p => p.id); // Example product IDs
                    const params = new URLSearchParams();

                    const ProductTypeId = this.search.product_type_id.map(
                        p => p.value
                    );

                    productIds.forEach(id => params.append("product_id[]", id));
                    ProductTypeId.forEach(id =>
                        params.append("product_type_id[]", id)
                    );

                    params.append("date", date);
                    const queryString = "?" + params.toString();

                    const response = await axios.get(
                        this.domain +
                            `/overview-product-invoice-search` +
                            queryString
                    );
                    this.response = response.data;
                    this.loading = false;
                }
            } catch (error) {
                console.error("Error during API call:", error);
            }
        },
        closeModal() {
            this.$refs.filter_emp_nation.hide();
        },
        customLabelType(option) {
            return `${option.text}`;
        },
        handleDateChange() {
            let dates = this.search.time.map(ts => new Date(ts)); // Convert timestamps to Date objects

            const diffInMs = dates[1] - dates[0]; // Difference in milliseconds
            const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

            if (diffInDays > 7) {
                alert("เลือกได้ไม่เกิน 7 วัน");
                this.search.time = [];
            }
        },
        adjustStickyHeader() {
            console.log('Function called'); // ตรวจสอบว่าฟังก์ชันถูกเรียกหรือไม่

            // ใช้ this.$nextTick เพื่อให้แน่ใจว่า DOM ถูก render เรียบร้อยแล้ว
            this.$nextTick(() => {
                const firstRow = document.querySelector('.table-sticky > thead > tr:first-child');
                console.log('First row element:', firstRow); // ตรวจสอบว่าหา element ได้หรือไม่

                if (firstRow) {
                    const firstRowHeight = firstRow.offsetHeight;
                    console.log('Row height:', firstRowHeight); // ตรวจสอบความสูงที่ได้

                    // อัพเดทค่า CSS Variable
                    document.documentElement.style.setProperty('--second-row-top', `${firstRowHeight}px`);

                    // ตรวจสอบว่า CSS Variable ถูกตั้งค่าหรือไม่
                    const computedStyle = getComputedStyle(document.documentElement);
                    console.log('CSS Variable value:', computedStyle.getPropertyValue('--second-row-top'));
                } else {
                    console.log('First row not found'); // กรณีไม่พบ element
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.loader {
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
}

.table.table-sticky {
    position: relative;
}

.table.table-sticky > thead > tr:nth-child(1) > th {
    position: sticky;
    top: 0;
    background-color: #ffbf00;
    z-index: 2;
}

.table.table-sticky > thead > tr:nth-child(2) > th {
    position: sticky;
    top: var(--second-row-top, 0); /* ใช้ CSS Variable */
    background-color: #ffbf00;
    z-index: 2;
}

/* สำหรับ th ที่มี rowspan="2" */
.table.table-sticky > thead > tr:nth-child(1) > th[rowspan="2"] {
    z-index: 3;
}

.table-container {
    max-height: 75vh;
    overflow-y: auto;
}
/* Safari */
@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
